export enum ServiceTypeEnum {
  Tailoring = 'Tailoring',
  Cleaning = 'Cleaning',
}